import React from 'react';
import { Alert } from '../atoms';
import type { LayoutClassNameProps } from '../atoms';

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement>, LayoutClassNameProps {
  variant?: 'warning' | 'info' | 'light';
}

const EmptyState: React.FC<EmptyStateProps> = ({
  variant = 'warning',
  className,
  children,
  ...props
}) => (
  <Alert variant={variant} className={className} {...props}>
    {children}
  </Alert>
);

export default EmptyState;
